import { render, staticRenderFns } from "./SlotLabelDialog.vue?vue&type=template&id=6638082c&scoped=true"
import script from "./SlotLabelDialog.vue?vue&type=script&lang=js"
export * from "./SlotLabelDialog.vue?vue&type=script&lang=js"
import style0 from "./SlotLabelDialog.vue?vue&type=style&index=0&id=6638082c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6638082c",
  null
  
)

export default component.exports